export default "__VITE_ASSET__BAwKl0ot__"